import WarningIcon from "@/icons/WarningIcon";
import { iconCss, rootCss, textCss } from "./AttachmentsErrorMessage.style";

const AttachmentsErrorMessage = () => {
  const messageText =
    "We're sorry, the activities aren't loading. Please try again later.";

  return (
    <div css={rootCss}>
      <WarningIcon css={iconCss} />
      <p css={textCss}>{messageText}</p>
    </div>
  );
};

export default AttachmentsErrorMessage;
